<div class="col-md-12">
    <hr/>
    <label class="form-labels mt-4">¿Hay solicitante conjunto?</label><br/>
    <div class="form-check form-check-inline">
        <input (change)="coSigner($event)" class="form-check-input" id="hasCosignerSi" type="radio" value="si" name="cosigner">
        <label class="form-check-label">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input (change)="coSigner($event)" class="form-check-input" id="hasCosignerNo" name="cosigner" type="radio" value="no">
        <label class="form-check-label">No</label>
      </div>
</div>

<div class="col-md-12 mt-4" *ngIf="showCoSigner">
    <hr/>
    <h5>Información sobre el solicitante conjunto</h5>
</div>

<div [formGroup]="form" class="row" id="cosigner" *ngIf="showCoSigner">
    <div class="col-md-6">
        <label class="form-labels mt-4">Nombre</label>
        <div class="input-group">
            <input formControlName="name" type="text" class="form-control">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Seguro Social</label>
        <div class="input-group">
            <input formControlName="ss" type="text" class="form-control" [brmasker]="{mask: '000-00-0000', type:'num'}" maxlength="11">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Número de Licencia</label>
        <div class="input-group">
            <input formControlName="licence" type="text" class="form-control">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Fecha de Nacimiento</label>
        <input formControlName="birthDate" type="date" class="form-control">
    </div>

    <app-address [address]="coSolicitante?.address" (formReady)="addChildForm('address', $event)"></app-address>

    <app-employer-info [employer]="coSolicitante?.employer" (formReady)="addChildForm('employer', $event)"></app-employer-info>
</div>